import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { requestSisenseJWT } from "store/state/auth";
import { getConfigItemByParentId } from "store/state/configItems";
import { CONFIGURABLE_URLS } from "constants/configItemParents";

let ssoAttempt = 0;

class SSOHandler extends React.Component {
  componentDidMount() {
    this.props.requestSisenseJWT();
    this.props.getConfigItemByParentId({ id: CONFIGURABLE_URLS });
  }

  render() {
    if (!this.props.sisenseJWT || !this.props.sisenseURL) {
      return null;
    }

    ssoAttempt = ssoAttempt + 1;
    if (ssoAttempt === 1) {
      const jwt = this.props.sisenseJWT;
      window.location.href = `https://${this.props.sisenseURL}/jwt?jwt=${jwt}`;
    }

    return (<div>Loading</div>);
  }
}

const mapStateToProps = ({ authentication, configItems }) => {
  return {
    sisenseJWT: authentication.sisenseJWT,
    sisenseURL: configItems &&
      configItems.configItemByParent[ CONFIGURABLE_URLS ] &&
      configItems.configItemByParent[ CONFIGURABLE_URLS ].filter(item => item.id === "fb26de17-1ccd-11ed-a0f6-027736c5c5ef").length > 0 ?
      configItems.configItemByParent[ CONFIGURABLE_URLS ].filter(item => item.id === "fb26de17-1ccd-11ed-a0f6-027736c5c5ef")[ 0 ].value : ""
  };
}

export default compose(
  connect(
    mapStateToProps, {
    requestSisenseJWT,
    getConfigItemByParentId
  }
  )
)(SSOHandler);
